module.exports = __webpack_public_path__ + "img/dr-illu-2.32dc999e.svg";